import React from 'react';
import { LogoSection } from './Header-LogoSection';
import { DesktopMenuSection } from './Header-DesktopMenuSection';
import { CartSection } from './Header-CartSection';
import { MobileMenuSection } from './Header-MobileMenuSection';
export function HeaderSection() {
  return <header className="bg-white shadow-sm sticky top-0 z-50 border-b-4 border-brand-yellow relative" data-id="element-432">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-433">
        <div className="flex justify-between items-center h-20" data-id="element-434">
          <LogoSection data-id="element-435" />
          <DesktopMenuSection data-id="element-436" />
          <CartSection data-id="element-437" />
          <MobileMenuSection data-id="element-438" />
        </div>
      </div>
    </header>;
}